// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"693":"6bce0f2d","710":"80d7102a","845":"94fb8283"}[chunkId] + ".chunk.js";
};